import React, { forwardRef } from 'react';
import { FaCheck } from 'react-icons/fa';

import { Container } from './styles';

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
}

// Compatível com o register do react-hook-form (repassa o ref ao input)
const Checkbox = forwardRef<HTMLInputElement, IProps>(({ label, style, className, ...rest }, ref) => (
  <Container style={style} className={className}>
    <input type='checkbox' ref={ref} {...rest} />
    <span className='caixa' aria-hidden><FaCheck size={11} /></span>
    <span>{label}</span>
  </Container>
));

export default Checkbox;
